// src: https://redux.js.org/docs/recipes/ReducingBoilerplate.html#generating-reducers
export function createReducer (initialState, handlers) {
  return function reducer (state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action.payload)
    } else {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/redux/createReducer.js